import { render, staticRenderFns } from "./your-tasting.vue?vue&type=template&id=f5ebee98&scoped=true&"
import script from "./your-tasting.vue?vue&type=script&lang=js&"
export * from "./your-tasting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ebee98",
  null
  
)

export default component.exports